import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";
import LayoutDefault from "../layout/LayoutDefault";
import LayoutProject from "../layout/LayoutProject";
import SetPassword from "../pages/auth/SetPassword";
import SuccessMain from "../pages/auth/SuccessMain";
import EmailError from "../pages/auth/EmailError";
import ResetPassword from "../pages/auth/ResetPassword";
import { useDispatch } from "react-redux";
import { fetchCurrentUser } from "../store/slices/misc/currentUser";

import { useSelector } from "react-redux";
import { updateAccessibility } from "../store/slices/misc/accessibility";
import { Flex, Spin } from "antd";
import { updateAllowedRoutes } from "../store/slices/misc/allowedRoutes";
import ProjectScheduleDashboard from "../pages/ProjectScheduleManagement/dashboard";
import InventoryAnalysis from "../pages/ProjectScheduleManagement/inventory/InventoryAnalysis";
import TrackPurchaseRequest from "../pages/ProjectScheduleManagement/inventory/TrackPurchaseRequest";
import ViewPurchaseRequest from "../pages/ProjectScheduleManagement/inventory/ViewPurchaseRequest";
import ViewQuotation from "../pages/ProjectScheduleManagement/inventory/ViewQuotation";
import ViewPurchaseOrder from "../pages/ProjectScheduleManagement/inventory/ViewPurchaseOrder";
import BudgetAnalysis from "../pages/ProjectScheduleManagement/budget/BudgetAnalysis";
import ProjectCreation from "../pages/ProjectScheduleManagement/projects/projectCreation";
import CalendarCreation from "../pages/ProjectScheduleManagement/calendar/calendarCreation";
import CalendarDetailPage from "../pages/ProjectScheduleManagement/calendar/CalendarDetailPage";
import CalendarCreationPage from "../pages/ProjectScheduleManagement/calendar/CalendarCreationPage";
import Cookies from "js-cookie";

import CheckListLists from "../pages/ProjectScheduleManagement/Checklist/CheckListLists";
import CreateChecklist from "../pages/ProjectScheduleManagement/Checklist/CreationChecklist";
import EditChecklist from "../pages/ProjectScheduleManagement/Checklist/EditChecklist";

import { LoadingOutlined } from "@ant-design/icons";
import AllProjectsListView from "../pages/ProjectScheduleManagement/projects/allProjectsListView";
import ProjectsHub from "../pages/ProjectScheduleManagement/projects/hub/ProjectsHub";
import GroupOfProjectsListView from "../pages/ProjectScheduleManagement/projects/GroupOfProjectsListView";
import PendingProjectsListView from "../pages/ProjectScheduleManagement/projects/PendingProjectsListView";
import RateCardList from "../pages/ProjectScheduleManagement/rateCard/RateCardList";
import NormList from "../pages/ProjectScheduleManagement/norms/NormList";
import ManpowerNormList from "../pages/ProjectScheduleManagement/manpower-norms/ManpowerNormList";
import MachineryNormList from "../pages/ProjectScheduleManagement/machinery-norms/MachineryNormList";
import AssetMasterList from "../pages/ProjectScheduleManagement/assets/AssetMasterList";
import CalendarList from "../pages/ProjectScheduleManagement/calendar/CalendarList";
import ProjectDetailsView from "../pages/ProjectScheduleManagement/projects/projectDetailsView";
import PhasesListView from "../pages/ProjectScheduleManagement/phases/PhasesListView";
import PhaseDetailPage from "../pages/ProjectScheduleManagement/phases/PhaseDetailPage";
import ActivityDetailPage from "../pages/ProjectScheduleManagement/activity/ActivityDetailPage";
import ProjectActivityListPage from "../pages/ProjectScheduleManagement/activity/ProjectActivityListPage";
import ActivityCreatePage from "../pages/ProjectScheduleManagement/activity/ActivityCreatePage";
import TaskDetailPage from "../pages/ProjectScheduleManagement/NewTasks/TaskDetailPage";
import IssueDetailPage from "../pages/ProjectScheduleManagement/issues/IssueDetailPage";
import TasksListView from "../pages/ProjectScheduleManagement/tasks/TasksListView";
import TaskCreatePage from "../pages/ProjectScheduleManagement/NewTasks/TaskCreatePage";
import TimeSheetsListView from "../pages/ProjectScheduleManagement/timeSheets/TimeSheetsListView";
import TimeLogDetailPage from "../pages/ProjectScheduleManagement/timeSheets/TimeLogDetailPage";
import IssuesListView from "../pages/ProjectScheduleManagement/issues/IssuesListView";
import ProjectUsersListView from "../pages/ProjectScheduleManagement/projects/ProjectUsersListView";
import ProjectTimeLog from "../pages/ProjectScheduleManagement/timeLogSettings/projectTimeLog";
import AllDraftProjectsListView from "../pages/ProjectScheduleManagement/draftProjects/AllDraftProjectsListView";
import AllClosedProjectsListView from "../pages/ProjectScheduleManagement/closedProjects/AllClosedProjectsListView";
import AllInactiveProjectsListView from "../pages/ProjectScheduleManagement/inactiveProjects/AllInactiveProjectsListView";
import AllArchivedProjectsListView from "../pages/ProjectScheduleManagement/archivedProjects/AllArchivedProjectsListView";
import AllRecycleBinProjectsListView from "../pages/ProjectScheduleManagement/recycleBinProjects/AllRecycleBinProjectsListView";
import ViewAllReportsList from "../pages/reports/ReportsNav";
import TaskReassignmentReportsList from "../pages/reports/TaskReassignmentReportsList";
import TaskAgingReport from "../pages/reports/TaskAgingReport";

import ChecklistAdherenceByUserReport from "../pages/reports/ChecklistAderenceByUserReport";
import UnAssignedTaskReport from "../pages/reports/UnAssignedTaskReport";
import OnHoldTasksReport from "../pages/reports/OnHoldTasksReport";
import ApprovalActionDelaysReport from "../pages/reports/ApprovalsActionDelaysReport";
import TagWiseTaskPerformanceReport from "../pages/reports/TagWiseTaskPerformanceReport";
import StatusWiseTaskPerformanceReport from "../pages/reports/StatusWiseTaskPerformanceReport";
import WorkCategoryWiseTaskReport from "../pages/reports/WorkCategoryWIseTaskReport";
import PhaseLevelPrograessSummaryReport from "../pages/reports/PhaseLevelProgressSummaryReport";
import ActivityLevelProgressSummaryReport from "../pages/reports/ActivityLevelProgressSummaryReport";
import TaskCompletionReport from "../pages/reports/TaskCompletionReports";
import TaskIssueTracker from "../pages/reports/TaskIssueTracker";
import BaselineVsCurrentTimelineReport from "../pages/reports/BaselineCurrentTimelineReport";
import DependencyViolationReport from "../pages/reports/DependencyViolationReport";
import UserWiseWorkloadReport from "../pages/reports/UserWiseWorkloadReport";
import UserWisePlannedActualsReport from "../pages/reports/UserWisePlannedActuals";
import TimeLogReports from "../pages/reports/TimelogReports";
import PettyCashReport from "../pages/reports/PettyCashReport";
import DailyProgressDigest from "../pages/reports/DailyProgressDigest";
import DailyApprovalsPage from "../pages/ProjectScheduleManagement/dailyApprovals/DailyApprovalsPage";
import DailyReportReviewPage from "../pages/ProjectScheduleManagement/dailyApprovals/DailyReportReviewPage";
import DocumentPage from "../pages/ProjectScheduleManagement/projectDocument/DocumentPage";
import TaskWiseTimeLogs from "../pages/reports/TaskWiseTimeLogs";
import ActivityWiseTimeLogs from "../pages/reports/ActivityWiseTimeLogs";
import PhaseWiseTimeLogs from "../pages/reports/PhaseWiseTimeLogs";
import SequenceList from "../pages/sequence/SequenceList";
import ExpenseReports from "../pages/expenses/ExpensesReports";
import NewExpense from "../pages/expenses/NewExpense";
import NewHeader from "../pages/expenses/NewHeader";
import NewAdvance from "../pages/expenses/NewAdvance";
import PaymentAdvances from "../pages/expenses/PaymentAdvances";
import PendingApproval from "../pages/expenses/PendingApproval";
import ExpensesAnalytics from "../pages/expenses/ExpensesAnalytics";
import Reports from "../pages/expenses/Reports";
import ReportBreakDown from "../pages/expenses/ReportBreakDown";
import Ledger from "../pages/expenses/Ledger";
import ExpenseDetailsReport from "../pages/expenses/reports/ExpenseDetailsReport";
import ExpenseUserReport from "../pages/expenses/reports/ExpenseUserReport";
import ExpenseVendorReport from "../pages/expenses/reports/ExpenseVendorReport";
import ExpenseCategoryReport from "../pages/expenses/reports/ExpenseCategoryReport";
import WBSView from "../pages/ProjectScheduleManagement/wbs/WBSView";
import WBSViewNew from "../pages/ProjectScheduleManagement/wbs/WBSViewNew";
import ThreeMConsolidationReport from "../pages/ProjectScheduleManagement/reports/ThreeMConsolidation";
import MaterialCostAnalysisReport from "../pages/ProjectScheduleManagement/reports/MaterialCostAnalysis";
import ManpowerCostAnalysisReport from "../pages/ProjectScheduleManagement/reports/ManpowerCostAnalysis";
import MachineryCostAnalysisReport from "../pages/ProjectScheduleManagement/reports/MachineryCostAnalysis";
import ThreeMDeviationSummaryReport from "../pages/ProjectScheduleManagement/reports/ThreeMDeviationSummary";
import InternalTaskSummaryReport from "../pages/ProjectScheduleManagement/reports/InternalTaskSummary";
import MonthlyPnlReport from "../pages/ProjectScheduleManagement/reports/MonthlyPnl";
import MonthlyPnlMonthDetailPage from "../pages/ProjectScheduleManagement/reports/MonthlyPnl/MonthDetailPage";
import ProjectCashEntries from "../pages/ProjectScheduleManagement/project-cash/ProjectCashEntries";
import MonthlyExecutionReport from "../pages/ProjectScheduleManagement/reports/MonthlyExecution";
import MonthlyExecutionMonthDetailPage from "../pages/ProjectScheduleManagement/reports/MonthlyExecution/MonthDetailPage";
import MonthlyExecutionAnalysisPage from "../pages/ProjectScheduleManagement/reports/MonthlyExecution/AnalysisPage";
import DailyExecutionPage from "../pages/ProjectScheduleManagement/execution/DailyExecutionPage";
import DrivesPage from "../pages/ProjectScheduleManagement/execution/DrivesPage";
import TaskMonitoringPage from "../pages/ProjectScheduleManagement/execution/TaskMonitoringPage";
import ExecutionNormsPage from "../pages/ProjectScheduleManagement/execution/ExecutionNormsPage";
import ExcelExportRequestedList from "../pages/pre-built/user-manage/ExcelExportRequestedList";
import BulkUploadList from "../pages/pre-built/user-manage/ExcelUploadRequestedList";
import ConsolidatedDashboard from "../pages/ProjectScheduleManagement/consolidatedDashboard/consolidatedDashboard";
import NotificationMain from "../pages/notifications/NotificationMain";
import Terms from "../pages/others/Terms";
import Faq from "../pages/others/Faq";

const globalRoutes = [
  "/",
  "/auth-reset",
  "/auth-success",
  "/auth-register",
  "/setPassword",
  "/success",
  "/errorEmail",
  "/privacy",
  // "/notifications",
];

const ScheduleManagement = {
  "pms/dashboard": <ProjectScheduleDashboard />,
  // "pms/projects": <Projects />,
  "pms/main-dashboard": <ConsolidatedDashboard />,
  "pms/active-projects": <AllProjectsListView />,
  "pms/groups-projects": <GroupOfProjectsListView />,
  "pms/pending-approvals": <PendingProjectsListView />,
  "pms/rate-cards": <RateCardList />,
  "pms/norms": <NormList />,
  "pms/manpower-norms": <ManpowerNormList />,
  "pms/machinery-norms": <MachineryNormList />,
  "pms/assets": <AssetMasterList />,
  "pms/calendar": <CalendarList />,
  "pms/excelexport-requested-list": <ExcelExportRequestedList />,
  "pms/bulk-upload-list": <BulkUploadList />,

  "pms/project/dashboard": <ProjectScheduleDashboard />,
  "pms/project/view": <ProjectDetailsView />,
  "pms/project/phases": <PhasesListView />,
  "pms/project/activities": <ProjectActivityListPage />,
  "pms/project/tasks": <TasksListView />,
  "pms/project/issues": <IssuesListView />,
  "pms/project/daily-approvals": <DailyApprovalsPage />,
  "pms/project/documents": <DocumentPage />,
  "pms/project/timesheet": <TimeSheetsListView />,
  "pms/project/reports": <ViewAllReportsList />,
  "pms/project/inventory-analysis": <InventoryAnalysis />,
  "pms/project/budget-analysis": <BudgetAnalysis />,
  "pms/project/project-users": <ProjectUsersListView />,
  "pms/project/time-log-settings": <ProjectTimeLog />,

  "pms/draftProjects": <AllDraftProjectsListView />,
  "pms/closed-projects": <AllClosedProjectsListView />,
  "pms/inactive-projects": <AllInactiveProjectsListView />,
  "pms/archived-projects": <AllArchivedProjectsListView />,
  "pms/recycle-bin": <AllRecycleBinProjectsListView />,

  "pms/analytics": <ProjectScheduleDashboard />,
  "pms/project-creation": <ProjectCreation />,
  "pms/calendar-creation": <CalendarCreation />,
  // "pms/Checklist/checklist-lists": <CheckListLists />,
  // "pages/checklist/create": <CreateChecklist />,
  // "pages/checklist/edit": <EditChecklist />,

  // "pms/projectDetailModal": <ProjectDetailModal />,
  "pms/task-reassignment-reports-list": <TaskReassignmentReportsList />,
  "pms/task-aging-report": <TaskAgingReport />,
  "pms/checklist-adherence-by-user-report": <ChecklistAdherenceByUserReport />,
  "pms/unassigned-task-report": <UnAssignedTaskReport />,
  "pms/onhold-tasks-report": <OnHoldTasksReport />,
  "pms/approvals-action-delays-report": <ApprovalActionDelaysReport />,
  "pms/tagwise-task-performance-report": <TagWiseTaskPerformanceReport />,
  "pms/statuswise-task-performance-report": <StatusWiseTaskPerformanceReport />,
  "pms/work-category-wise-task-performance-report": (
    <WorkCategoryWiseTaskReport />
  ),
  "pms/phase-level-progress-summary-report": (
    <PhaseLevelPrograessSummaryReport />
  ),
  "pms/activity-level-progress-summary-report": (
    <ActivityLevelProgressSummaryReport />
  ),
  "pms/task-completion-report": <TaskCompletionReport />,
  "pms/task-issue-tracker": <TaskIssueTracker />,
  "pms/baseline-current-timeline-report": <BaselineVsCurrentTimelineReport />,
  "pms/dependency-violation-report": <DependencyViolationReport />,
  "pms/userwise-workload-report": <UserWiseWorkloadReport />,
  "pms/userwise-planned-actuals-report": <UserWisePlannedActualsReport />,
  "pms/time-log-reports": <TimeLogReports />,
  "pms/petty-cash-inflow-outflow-report": <PettyCashReport />,
  "pms/daily-progress-digest": <DailyProgressDigest />,
  "pms/time-log-analysis-report": <TaskWiseTimeLogs />,
  "pms/task-wise-timelogs": <TaskWiseTimeLogs />,
  "pms/activity-wise-timelogs": <ActivityWiseTimeLogs />,
  "pms/phase-wise-timelogs": <PhaseWiseTimeLogs />,
  "pms/sequence/SequenceList": <SequenceList />,
  "pms/expenses/ExpensesReports": <ExpenseReports />,
  "pms/expenses/new-expense": <NewExpense />,
  "pms/expenses/new-header": <NewHeader />,
  "pms/expenses/new-advance": <NewAdvance />,
  "pms/expenses/payment-advances": <PaymentAdvances />,
  "pms/expenses/pending-approval": <PendingApproval />,
  "pms/expenses/analytics": <ExpensesAnalytics />,
  "pms/expenses/reports": <Reports />,
  "pms/expenses/report-breakdown": <ReportBreakDown />,
  "pms/expenses/ledger": <Ledger />,
  "pms/expenses/expense-details-report": <ExpenseDetailsReport />,
  "pms/expenses/expense-user-report": <ExpenseUserReport />,
  "pms/expenses/expense-vendor-report": <ExpenseVendorReport />,
  "pms/expenses/expense-category-report": <ExpenseCategoryReport />,
};

const Pages = ({ setIsLoggedIn }) => {
  // const { data: allowedRoutes } = useSelector((state) => state.allowedRoutes);
  // const [menu, setMenu] = useState(null);
  const { data: currentUser } = useSelector((state) => state.currentUser);
  const [accessibility, setAccessibility] = useState([]);
  const [restrictedRoutes, setRestrictedRoutes] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  useLayoutEffect(() => {
    // console.clear();
    // console.log("location", location.pathname);
    // const rootPath = location.pathname.split("/")[1];
    // const rootPath = location.pathname;
    // console.log("rootPath", rootPath);
    // switch (rootPath) {
    //   case "psm":
    //     setMenu(TopMenu?.scheduleManagement);
    //     break;
    //   default:
    //     // setMenu(TopMenu?.procurement);
    // }

    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const isAuthenticated = Cookies.get("access-token");
    if (
      !currentUser &&
      isAuthenticated &&
      !globalRoutes?.includes(window.location.pathname)
    ) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.userRoutePermissions) {
      try {
        // dispatch(fetchSequenceAccess());
        const { userRoutePermissions } = currentUser;
        const decodedString = atob(userRoutePermissions);
        const decodedData = JSON.parse(decodedString);
        console.log("decodedData", JSON.stringify(decodedData));
        dispatch(updateAccessibility(decodedData));
        const _allowedRoutes = [];
        const _restrictedRoutes = [];
        Object.keys(decodedData).forEach((mod) => {
          const module = decodedData[mod];
          if (module?.access) {
            module?.routes?.forEach((route) => {
              if (route?.permission) {
                _allowedRoutes.push(route?.path);
              } else {
                _restrictedRoutes.push(route?.path);
              }
            });
          }
        });

        setAccessibility(_allowedRoutes);
        setRestrictedRoutes(_restrictedRoutes);

        dispatch(updateAllowedRoutes(_allowedRoutes));
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [currentUser]);

  const isAuthenticated = Cookies.get("access-token");
  if (!isAuthenticated && !globalRoutes?.includes(window.location.pathname)) {
    window.location.href = "/";
  }

  return (
    <Routes>
      {/* Default Layout - Main pages with top navigation only (no sidebar) */}
      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutDefault />}>
        <Route path="notifications" element={<NotificationMain />} />
        <Route path="terms-policy" element={<Terms />} />
        <Route path="privacy" element={<Faq />} />
        <Route path="pms/main-dashboard" element={<ConsolidatedDashboard />} />
        <Route path="pms/projects" element={<ProjectsHub />} />
        {/* Legacy per-status URLs converge on the unified Projects hub */}
        <Route path="pms/active-projects" element={<Navigate to="/pms/projects?status=Active" replace />} />
        <Route path="pms/draftProjects" element={<Navigate to="/pms/projects?status=Draft" replace />} />
        <Route path="pms/closed-projects" element={<Navigate to="/pms/projects?status=Closed" replace />} />
        <Route path="pms/inactive-projects" element={<Navigate to="/pms/projects?status=Inactive" replace />} />
        <Route path="pms/archived-projects" element={<Navigate to="/pms/projects?status=Archived" replace />} />
        <Route path="pms/groups-projects" element={<GroupOfProjectsListView />} />
        <Route path="pms/recycle-bin" element={<AllRecycleBinProjectsListView />} />
        <Route path="pms/pending-approvals" element={<PendingProjectsListView />} />
        <Route path="pms/rate-cards" element={<RateCardList />} />
        <Route path="pms/norms" element={<NormList />} />
        <Route path="pms/manpower-norms" element={<ManpowerNormList />} />
        <Route path="pms/machinery-norms" element={<MachineryNormList />} />
        <Route path="pms/execution-norms" element={<ExecutionNormsPage />} />
        <Route path="pms/execution-norms/:projectId" element={<ExecutionNormsPage />} />
        <Route path="pms/assets" element={<AssetMasterList />} />
        <Route path="pms/calendar" element={<CalendarList />} />
        <Route path="pms/calendar-detail/:calendarId" element={<CalendarDetailPage />} />
        <Route path="pms/Checklist/checklist-lists" element={<CheckListLists />} />
        <Route path="pages/checklist/create" element={<CreateChecklist />} />
        <Route path="pages/checklist/edit" element={<EditChecklist />} />

        {/* Reports Routes */}
        <Route path="pms/task-reassignment-reports-list" element={<TaskReassignmentReportsList />} />
        <Route path="pms/task-aging-report" element={<TaskAgingReport />} />
        <Route path="pms/checklist-adherence-by-user-report" element={<ChecklistAdherenceByUserReport />} />
        <Route path="pms/unassigned-task-report" element={<UnAssignedTaskReport />} />
        <Route path="pms/onhold-tasks-report" element={<OnHoldTasksReport />} />
        <Route path="pms/approvals-action-delays-report" element={<ApprovalActionDelaysReport />} />
        <Route path="pms/tagwise-task-performance-report" element={<TagWiseTaskPerformanceReport />} />
        <Route path="pms/statuswise-task-performance-report" element={<StatusWiseTaskPerformanceReport />} />
        <Route path="pms/work-category-wise-task-performance-report" element={<WorkCategoryWiseTaskReport />} />
        <Route path="pms/phase-level-progress-summary-report" element={<PhaseLevelPrograessSummaryReport />} />
        <Route path="pms/activity-level-progress-summary-report" element={<ActivityLevelProgressSummaryReport />} />
        <Route path="pms/task-completion-report" element={<TaskCompletionReport />} />
        <Route path="pms/task-issue-tracker" element={<TaskIssueTracker />} />
        <Route path="pms/baseline-current-timeline-report" element={<BaselineVsCurrentTimelineReport />} />
        <Route path="pms/dependency-violation-report" element={<DependencyViolationReport />} />
        <Route path="pms/userwise-workload-report" element={<UserWiseWorkloadReport />} />
        <Route path="pms/userwise-planned-actuals-report" element={<UserWisePlannedActualsReport />} />
        <Route path="pms/time-log-reports" element={<TimeLogReports />} />
        <Route path="pms/petty-cash-inflow-outflow-report" element={<PettyCashReport />} />
        <Route path="pms/daily-progress-digest" element={<DailyProgressDigest />} />
        <Route path="pms/time-log-analysis-report" element={<TaskWiseTimeLogs />} />
        <Route path="pms/task-wise-timelogs" element={<TaskWiseTimeLogs />} />
        <Route path="pms/activity-wise-timelogs" element={<ActivityWiseTimeLogs />} />
        <Route path="pms/phase-wise-timelogs" element={<PhaseWiseTimeLogs />} />

        {/* Project Creation */}
        <Route path="pms/project-creation" element={<ProjectCreation />} />
        <Route path="pms/calendar-creation" element={<CalendarCreationPage />} />
      </Route>

      {/* Project Layout - Project detail pages with sidebar */}
      <Route path={`${process.env.PUBLIC_URL}pms/project`} element={<LayoutProject />}>
        <Route path="dashboard" element={<ProjectScheduleDashboard />} />
        <Route path="dashboard/:projectId" element={<ProjectScheduleDashboard />} />
        <Route path="view" element={<ProjectDetailsView />} />
        <Route path="view/:projectId" element={<ProjectDetailsView />} />
        <Route path="phases" element={<PhasesListView />} />
        <Route path="phases/:projectId" element={<PhasesListView />} />
        <Route path="phase-detail/:phaseId" element={<PhaseDetailPage />} />
        <Route path="activities" element={<ProjectActivityListPage />} />
        <Route path="activities/:projectId" element={<ProjectActivityListPage />} />
        <Route path="activity-create" element={<ActivityCreatePage />} />
        <Route path="activity-create/:projectId" element={<ActivityCreatePage />} />
        <Route path="activity-detail/:activityId" element={<ActivityDetailPage />} />
        <Route path="task-detail/:taskId" element={<TaskDetailPage />} />
        <Route path="issue-detail/:issueId" element={<IssueDetailPage />} />
        <Route path="tasks" element={<TasksListView />} />
        <Route path="tasks/:projectId" element={<TasksListView />} />
        <Route path="task-create" element={<TaskCreatePage />} />
        <Route path="task-create/:projectId" element={<TaskCreatePage />} />
        <Route path="issues" element={<IssuesListView />} />
        <Route path="issues/:projectId" element={<IssuesListView />} />
        <Route path="daily-approvals" element={<DailyApprovalsPage />} />
        <Route path="daily-approvals/:projectId" element={<DailyApprovalsPage />} />
        <Route path="daily-approvals/review/:projectId/:date" element={<DailyReportReviewPage />} />
        <Route path="documents" element={<DocumentPage />} />
        <Route path="documents/:projectId" element={<DocumentPage />} />
        <Route path="timesheet" element={<TimeSheetsListView />} />
        <Route path="timesheet/:projectId" element={<TimeSheetsListView />} />
        <Route path="timelog-detail/:timeLogId" element={<TimeLogDetailPage />} />
        <Route path="reports" element={<ViewAllReportsList />} />
        <Route path="reports/:projectId" element={<ViewAllReportsList />} />
        <Route path="inventory-analysis" element={<InventoryAnalysis />} />
        <Route path="inventory-analysis/:projectId" element={<InventoryAnalysis />} />
        <Route path="track-purchase-requests/:prId" element={<TrackPurchaseRequest />} />
        <Route path="view-pr/:prId" element={<ViewPurchaseRequest />} />
        <Route path="view-quotation/:quotationId" element={<ViewQuotation />} />
        <Route path="view-purchase-order/:orderNumber" element={<ViewPurchaseOrder />} />
        <Route path="budget-analysis" element={<BudgetAnalysis />} />
        <Route path="budget-analysis/:projectId" element={<BudgetAnalysis />} />
        <Route path="project-users" element={<ProjectUsersListView />} />
        <Route path="project-users/:projectId" element={<ProjectUsersListView />} />
        <Route path="time-log-settings" element={<ProjectTimeLog />} />
        <Route path="time-log-settings/:projectId" element={<ProjectTimeLog />} />
        <Route path="wbs" element={<WBSViewNew />} />
        <Route path="wbs/:projectId" element={<WBSViewNew />} />
        <Route path="3m-consolidation" element={<ThreeMConsolidationReport />} />
        <Route path="3m-consolidation/:projectId" element={<ThreeMConsolidationReport />} />
        <Route path="material-cost-analysis" element={<MaterialCostAnalysisReport />} />
        <Route path="material-cost-analysis/:projectId" element={<MaterialCostAnalysisReport />} />
        <Route path="manpower-cost-analysis" element={<ManpowerCostAnalysisReport />} />
        <Route path="manpower-cost-analysis/:projectId" element={<ManpowerCostAnalysisReport />} />
        <Route path="machinery-cost-analysis" element={<MachineryCostAnalysisReport />} />
        <Route path="machinery-cost-analysis/:projectId" element={<MachineryCostAnalysisReport />} />
        <Route path="deviation-summary" element={<ThreeMDeviationSummaryReport />} />
        <Route path="deviation-summary/:projectId" element={<ThreeMDeviationSummaryReport />} />
        <Route path="internal-task-summary" element={<InternalTaskSummaryReport />} />
        <Route path="internal-task-summary/:projectId" element={<InternalTaskSummaryReport />} />
        <Route path="monthly-pnl" element={<MonthlyPnlReport />} />
        <Route path="monthly-pnl/:projectId" element={<MonthlyPnlReport />} />
        <Route path="monthly-pnl-month" element={<MonthlyPnlMonthDetailPage />} />
        <Route path="monthly-pnl-month/:projectId" element={<MonthlyPnlMonthDetailPage />} />
        <Route path="project-cash-entries" element={<ProjectCashEntries />} />
        <Route path="project-cash-entries/:projectId" element={<ProjectCashEntries />} />
        <Route path="monthly-execution" element={<MonthlyExecutionReport />} />
        <Route path="monthly-execution/:projectId" element={<MonthlyExecutionReport />} />
        <Route path="monthly-execution-month" element={<MonthlyExecutionMonthDetailPage />} />
        <Route path="monthly-execution-month/:projectId" element={<MonthlyExecutionMonthDetailPage />} />
        <Route path="monthly-execution-analysis" element={<MonthlyExecutionAnalysisPage />} />
        <Route path="monthly-execution-analysis/:projectId" element={<MonthlyExecutionAnalysisPage />} />
        <Route path="daily-execution" element={<DailyExecutionPage />} />
        <Route path="daily-execution/:projectId" element={<DailyExecutionPage />} />
        <Route path="task-monitoring" element={<TaskMonitoringPage />} />
        <Route path="task-monitoring/:projectId" element={<TaskMonitoringPage />} />
        <Route path="drives" element={<DrivesPage />} />
        <Route path="drives/:projectId" element={<DrivesPage />} />
      </Route>

      {/* Sequence with Project Layout */}
      <Route path={`${process.env.PUBLIC_URL}pms/sequence`} element={<LayoutProject />}>
        <Route path="SequenceList" element={<SequenceList />} />
        <Route path="SequenceList/:projectId" element={<SequenceList />} />
      </Route>

      {/* Expenses with Project Layout */}
      <Route path={`${process.env.PUBLIC_URL}pms/expenses`} element={<LayoutProject />}>
        <Route path="new-expense" element={<NewExpense />} />
        <Route path="new-expense/:projectId" element={<NewExpense />} />
        <Route path="new-header" element={<NewHeader />} />
        <Route path="new-header/:projectId" element={<NewHeader />} />
        <Route path="new-advance" element={<NewAdvance />} />
        <Route path="new-advance/:projectId" element={<NewAdvance />} />
        <Route path="payment-advances" element={<PaymentAdvances />} />
        <Route path="payment-advances/:projectId" element={<PaymentAdvances />} />
        <Route path="pending-approval" element={<PendingApproval />} />
        <Route path="pending-approval/:projectId" element={<PendingApproval />} />
        <Route path="ledger" element={<Ledger />} />
        <Route path="ledger/:projectId" element={<Ledger />} />
        <Route path="ExpensesReports" element={<ExpenseReports />} />
        <Route path="ExpensesReports/:projectId" element={<ExpenseReports />} />
        <Route path="analytics" element={<ExpensesAnalytics />} />
        <Route path="analytics/:projectId" element={<ExpensesAnalytics />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:projectId" element={<Reports />} />
        <Route path="report-breakdown" element={<ReportBreakDown />} />
        <Route path="report-breakdown/:projectId" element={<ReportBreakDown />} />
        <Route path="expense-details-report" element={<ExpenseDetailsReport />} />
        <Route path="expense-details-report/:projectId" element={<ExpenseDetailsReport />} />
        <Route path="expense-user-report" element={<ExpenseUserReport />} />
        <Route path="expense-user-report/:projectId" element={<ExpenseUserReport />} />
        <Route path="expense-vendor-report" element={<ExpenseVendorReport />} />
        <Route path="expense-vendor-report/:projectId" element={<ExpenseVendorReport />} />
        <Route path="expense-category-report" element={<ExpenseCategoryReport />} />
        <Route path="expense-category-report/:projectId" element={<ExpenseCategoryReport />} />
      </Route>

      {/* Imports/Exports with Project Layout */}
      <Route path={`${process.env.PUBLIC_URL}pms`} element={<LayoutProject />}>
        <Route path="bulk-upload-list" element={<BulkUploadList />} />
        <Route path="bulk-upload-list/:projectId" element={<BulkUploadList />} />
        <Route path="excelexport-requested-list" element={<ExcelExportRequestedList />} />
        <Route path="excelexport-requested-list/:projectId" element={<ExcelExportRequestedList />} />
      </Route>

      {/* Auth Layout - No navigation */}
      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-reset" element={<ResetPassword />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route index element={<Login setIsLoggedIn={setIsLoggedIn} />}></Route>
        <Route path="setPassword" element={<SetPassword />}></Route>
        <Route path="success" element={<SuccessMain />}></Route>
        <Route path="errorEmail" element={<EmailError />}></Route>
        <Route
          path="*"
          element={
            accessibility.length === 0 ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin
                    indicator={<LoadingOutlined spin />}
                    className="m-auto"
                    size="large"
                  />
                </Flex>
              </>
            ) : (
              <Error404Modern />
            )
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
